export default {
    entity: 'Company',
    name: 'Name',
    country: 'Country',
    createdAt: 'Created At',
    updatedAt: 'Last Updated',
    noData: 'No companies',
    active: 'Active',
};
